<template>
  <section class="about-company-edit">
    <h2
      class="title-small"
      style="margin-bottom: 39px"
    >
      {{ $t('about-company') }}
    </h2>
    <AboutCompany
      :input-name="inputName"
      :value-body="valueBody"
      @valueBodyChange="valueBody = $event"
    />
    <ButtonsBottom />
  </section>
</template>

<script>
    import AboutCompany from '../factory/parts/AboutCompany.vue'
    import ButtonsBottom from '../ButtonsBottom.vue'

    export default {
        name: 'AboutCompanyEdit',
        components: { ButtonsBottom, AboutCompany },
        props: {
            valueBodyStart: {},
            inputName: {
                required: true,
                type: String,
            },
        },
        data: () => ({
           valueBody: '',
        }),
        beforeMount() {
            if (this.valueBodyStart) {
                this.valueBody = this.valueBodyStart
            }
        },
    }
</script>

<style scoped>

</style>
